import { Client } from 'api/utils';
import { Config } from 'models/Config';

export const getConfig = async (): Promise<Config> => {
  const response = await Client.get('/config', {
    params: { bypassAuth: true },
  });
  return response.data;
};
